import {
  Box,
  Grid,
  Button,
  Paper,
  Typography,
  CircularProgress,
} from "@mui/material";
import React, { useState } from "react";
import eyebox from "../../Utils/Images/eyebox.png";
import bluetick from "../../Utils/Images/bluetick.png";
import cancelbox from "../../Utils/Images/cancelbox.png";
import { Link } from "react-router-dom";
import { handleUpdateOrder } from "../../APIs/Function/Order/EditOrderStatus";
import { GetOrder } from "../../APIs/Function/Order/GetOrder";
import CancelModal from "../Modal/CancelModal";
import OTPmodal from "../Modal/OTPmodal";
import Loader from "../Loader/Loader";

const OrderTable = ({ orderData, setOrderData, setLoading, loading }) => {
  const [cancelOpen, setCancelOpen] = useState(false);
  const [modalID, setModalId] = useState("");
  const [Open, setOpen] = useState(false);

  const sortedOrderData = orderData?.slice().sort((a, b) => {
    if (a.order_status === 1 && b.order_status !== 1) {
      return -1;
    } else if (a.order_status !== 1 && b.order_status === 1) {
      return 1;
    }
    return 0;
  });

  const closed = () => {
    setCancelOpen(false);
  };
  const updateStatus = async (e) => {
    let status;

    if (e.order_status === 0) {
      status = 1;
    } else {
      status = 2;
    }
    if (status === 2) {
      setOpen(true);
      setModalId(e.id);
    } else {
      confirmUpdate(e, status);
    }
  };
  const confirmComplete = async (status, id, otp) => {
    setOpen(false);
    try {
      setLoading(true);
      setCancelOpen(false);
      let res = await handleUpdateOrder(status, id, otp);
      let ans = await GetOrder();
      alert(res.m);
      setLoading(false);
      setOrderData(ans.r);
    } catch (error) {
      console.error("Error ", error);
    }
  };

  const confirmUpdate = async (e, status, otp) => {
    try {
      setLoading(true);
      setCancelOpen(false);
      await handleUpdateOrder(status, e.id, otp);
      // alert("Order Cancelled Successfully");
      let res = await GetOrder();
      setLoading(false);
      setOrderData(res.r);
    } catch (error) {
      console.error("Error ", error);
    }
  };

  const cancelOrder = (id) => {
    setCancelOpen(true);
    setModalId(id);
  };

  const confirmCancel = async () => {
    try {
      setLoading(true);
      setCancelOpen(false);
      await handleUpdateOrder(3, modalID);
      alert("Order Cancelled Successfully");
      let res = await GetOrder();
      setLoading(false);
      setOrderData(res.r);
    } catch (error) {
      console.error("Error Cancel Order:", error);
    }
  };

  return (
    <>
      {" "}
      {loading ? (
        <Box sx={{ mt: "25%" }}>
          <Loader />
        </Box>
      ) : (
        <Box>
          {/* heading */}
          <Box
            sx={{
              boxShadow: "none",
              outline: "none",
              mb: "10px",
              border: "none",
              mt: "10px",
              boxSizing: "border-box",
            }}
          >
            <Grid container>
              {/* first column */}
              <Grid item xs={0.5} md={0.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",
                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    #
                  </Typography>
                </Paper>
              </Grid>
              {/* Second Column */}
              <Grid item xs={2} md={2}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    Order ID
                  </Typography>
                </Paper>
              </Grid>
              {/* Third Column */}
              <Grid item xs={2} md={2}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    Username
                  </Typography>
                </Paper>
              </Grid>
              {/* Fourth Column */}
              <Grid item xs={2} md={2}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    User Email
                  </Typography>
                </Paper>
              </Grid>
              {/* fifth Column */}
              <Grid item xs={2} md={2}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    Order Status
                  </Typography>
                </Paper>
              </Grid>
              {/* Sixth Column */}
              <Grid item xs={2} md={2}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    Number Of Product
                  </Typography>
                </Paper>
              </Grid>
              {/* Seventh Column */}
              <Grid item xs={1.5} md={1.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    Action
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              border: "1px solid #DDDDDD",
              height: "100%",
              overflow: "auto",
              "&:hover": {
                "::-webkit-scrollbar": {
                  width: "5px",
                  borderRadius: "10px",
                },
                "::-webkit-scrollbar-thumb": {
                  bgcolor: "gray",
                  borderRadius: "10px",
                },
              },
              mt: "10px",
              borderTop: "0.5px solid #DDDDDD",
              maxHeight: "75vh",
            }}
          >
            <Box>
              <Grid container>
                {/* first column */}
                <Grid item xs={0.5} md={0.5}>
                  {sortedOrderData?.map((item, i) => (
                    <Paper
                      sx={{
                        border: "0.5px solid #DDDDDD",
                        borderRadius: "0px",
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                      }}
                      key={`column0 + ${i}`}
                    >
                      <Typography
                        sx={{
                          fontFamily: "inter",
                          fontWeight: "400",
                          fontSize: "16px",
                        }}
                      >
                        {i + 1}
                      </Typography>
                    </Paper>
                  ))}
                </Grid>
                {/* Second Column */}
                <Grid item xs={2} md={2}>
                  {sortedOrderData?.map((item, i) => (
                    <Paper
                      sx={{
                        border: "0.5px solid #DDDDDD",
                        borderRadius: "0px",
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                        bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                      }}
                      key={`column1 + ${i}`}
                    >
                      <Typography
                        sx={{
                          fontFamily: "inter",
                          fontWeight: "400",
                          fontSize: "16px",
                        }}
                      >
                        {item.unique_order_id}
                      </Typography>
                    </Paper>
                  ))}
                </Grid>
                {/* Third Column */}
                <Grid item xs={2} md={2}>
                  {sortedOrderData?.map((item, i) => (
                    <Paper
                      sx={{
                        border: "0.5px solid #DDDDDD",
                        borderRadius: "0px",
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                        bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                      }}
                      key={`column2 + ${i}`}
                    >
                      <Typography
                        sx={{
                          fontFamily: "inter",
                          fontWeight: "400",
                          fontSize: "16px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          maxWidth: "90%",
                          "&:hover": {
                            overflow: "visible",
                          },
                        }}
                      >
                        {item.user_name}
                      </Typography>
                    </Paper>
                  ))}
                </Grid>
                {/* Fourth Column */}
                <Grid item xs={2} md={2}>
                  {sortedOrderData?.map((item, i) => (
                    <Paper
                      sx={{
                        border: "0.5px solid #DDDDDD",
                        borderRadius: "0px",
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                        bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                      }}
                      key={`column3 + ${i}`}
                    >
                      <Typography
                        sx={{
                          fontFamily: "inter",
                          fontWeight: "400",
                          fontSize: "16px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          maxWidth: "90%",
                          "&:hover": {
                            overflow: "visible",
                          },
                        }}
                      >
                        {item.email}
                      </Typography>
                    </Paper>
                  ))}
                </Grid>
                {/* fifth Column */}
                <Grid item xs={2} md={2}>
                  {sortedOrderData?.map((item, i) => (
                    <Paper
                      sx={{
                        border: "0.5px solid #DDDDDD",
                        borderRadius: "0px",
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                        bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                      }}
                      key={`column4 + ${i}`}
                    >
                      <Button
                        sx={{
                          fontFamily: "inter",
                          fontWeight: "400",
                          fontSize: "16px",
                          bgcolor:
                            item.order_status === -1
                              ? "#D30A0A"
                              : item.order_status === 1
                              ? "#BF7E32"
                              : item.order_status === 2
                              ? "#079804"
                              : item.order_status === 0
                              ? "#31AEF4"
                              : "#D30A0A",
                          color: "#ffffff",
                          textTransform: "capitalize",
                          "&:hover": {
                            bgcolor:
                              item.order_status === -1
                                ? "#D30A0A"
                                : item.order_status === 1
                                ? "#BF7E32"
                                : item.order_status === 2
                                ? "#079804"
                                : item.order_status === 0
                                ? "#31AEF4"
                                : "#D30A0A",
                          },
                          height: "40px",
                          maxWidth: "95%",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <Typography
                          sx={{
                            textOverflow: "ellipsis",
                            maxWidth: "100%",
                            m: "auto",
                            overflow: "hidden",
                          }}
                        >
                          {item.order_status === 0
                            ? "Pending"
                            : item.order_status === 1
                            ? "Ready To Dispatch"
                            : item.order_status === 2
                            ? "Completed"
                            : "Failed"}
                        </Typography>
                      </Button>
                    </Paper>
                  ))}
                </Grid>
                {/* Sixth Column */}
                <Grid item xs={2} md={2}>
                  {sortedOrderData?.map((item, i) => (
                    <Paper
                      sx={{
                        border: "0.5px solid #DDDDDD",
                        borderRadius: "0px",
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                        bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                      }}
                      key={`column5 + ${i}`}
                    >
                      <Button
                        sx={{
                          fontFamily: "inter",
                          fontWeight: "400",
                          fontSize: "16px",
                          bgcolor: "#31AEF4",
                          color: "#ffffff",
                          textTransform: "capitalize",
                          "&:hover": {
                            bgcolor: "#31AEF4",
                          },
                        }}
                      >
                        {item.no_of_products}
                      </Button>
                    </Paper>
                  ))}
                </Grid>
                {/* Seventh Column */}
                <Grid item xs={1.5} md={1.5}>
                  {sortedOrderData?.map((e, i) => (
                    <Paper
                      sx={{
                        border: "0.5px solid #DDDDDD",
                        borderRadius: "0px",
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                        bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                      }}
                      key={`column6 + ${i}`}
                    >
                      <Box
                        sx={{
                          p: "5px",
                          display: "flex",
                          width: "100%",
                          height: "70px",
                          justifyContent: "center",
                          gap: "5px",
                          alignItems: "center",
                        }}
                      >
                        <Box
                          sx={{
                            cursor: "pointer",
                            width: { xs: "50%", md: "25%" },
                            height: { xs: "50%", md: "50%" },
                          }}
                        >
                          <Link to={`/orderdetails/${e.id}`}>
                            <img width={"100%"} src={eyebox} alt="" />
                          </Link>
                        </Box>

                        <Box
                          sx={{
                            width: { xs: "50%", md: "25%" },
                            height: { xs: "50%", md: "50%" },
                            cursor: "pointer",
                            display:
                              e.order_status === 0 || e.order_status === 1
                                ? "block"
                                : "none",
                          }}
                          onClick={() => updateStatus(e)}
                        >
                          <img width={"100%"} src={bluetick} alt="" />
                        </Box>
                        <Box
                          sx={{
                            width: { xs: "50%", md: "25%" },
                            height: { xs: "50%", md: "50%" },
                            cursor: "pointer",
                            display: e.order_status === 0 ? "block" : "none",
                          }}
                          onClick={() => cancelOrder(e.id)}
                        >
                          <img width={"100%"} src={cancelbox} alt="" />
                        </Box>
                      </Box>
                    </Paper>
                  ))}
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      )}
      <CancelModal
        cancelOpen={cancelOpen}
        confirmCancel={confirmCancel}
        onClose={closed}
      />
      <OTPmodal Open={Open} modalID={modalID} confirmUpdate={confirmComplete} />
    </>
  );
};

export default OrderTable;
